export default "<p>\r\n  core works!\r\n</p>\r\n"